<template>
    <div class="Product-shop">
        <h2>
            <span >应用市场</span>
        </h2>
        <div class="Application-download-main">
            <ul>
                <li v-for="item in items" :key="item.name" class="Product-li">
                    <div class="img-and-name">
                        <img :src="require('../assets/img-Shop/'+ item.img)" alt="" class="Product-img">
                        <!-- <img src="../assets/img-Shop/android2.png" alt="" class="Product-img"> -->
                        <span class="Product-name">{{item.name}}</span>
                    </div>
                    <img src="../assets/img-Shop/下载.jpg" alt="" @click="download(item)" class="Product-download">
                </li>
            </ul>
        </div>
    </div>  
</template>

<script>
    export default {
        name: "Shop",
        data(){
            return{
                items: [
                    // {
                    //     img: require('../assets/img-Shop/pda.png'),
                    //     name: 'PDA',
                    //     id: "0",
                    //     address: "http://www.mifidata.cn:3389/pda.apk"
                    // },
                    // {
                    //     img: require('../assets/img-Shop/hdmi.png'),
                    //     name: 'HDMI V10.2.6',
                    //     id: "1",
                    //     address: "http://www.mifidata.cn:3389/HDMI.apk"
                    // },
                    // {
                    //     img: require('../assets/img-Shop/speedtest.png'),
                    //     name: 'speedtest V4.5.22',
                    //     id: "2",
                    //     address: "http://www.mifidata.cn:3389/Speedtest.apk"
                    // },
                    // {
                    //     img: require('../assets/img-Shop/sogou.png'),
                    //     name: '搜狗输入法 V11.3.1',
                    //     id: "3",
                    //     address: "http://www.mifidata.cn:3389/com.sohu.inputmethod.sogou_11.3_1620.apk"
                    // },
                    // {
                    //     img: require('../assets/img-Shop/beidou.png'),
                    //     name: '北斗伴 V11.1.3',
                    //     id: "4",
                    //     address: "http://www.mifidata.cn:3389/com.iflytek.inputmethod_11.1.3_14649.apk"
                    // },
                    // {
                    //     img: require('../assets/img-Shop/qq.png'),
                    //     name: 'QQ V8.8.88',
                    //     id: "5",
                    //     address: "http://www.mifidata.cn:3389/qq_8.8.88_2770.apk"
                    // },
                    // {
                    //     img: require('../assets/img-Shop/weixin.png'),
                    //     name: '微信 V8.0.22',
                    //     id: "6",
                    //     address: "http://www.mifidata.cn:3389/wx_8.0.22_2140.apk"
                    // },
                ],
            }
        },

        created(){
            this.readTestFile() 
        },

        methods:{
            download(item){
                var address = item.address
                window.location.href = address
            },

            readTestFile(){ 
                var file = this.loadFile('http://www.mifidata.cn/appjson.txt');
                file = this.unicodeToUtf8(file);
                if(file){
                    var data = JSON.parse(file);
                    this.items = data
                }
            }, 

            loadFile(url){
                const xhr = new XMLHttpRequest()
                const okStatus = document.location.protocol === 'file:' ? 0 : 200
                xhr.open('GET', url , false)
                xhr.overrideMimeType('text/html;charset=utf-8')
                xhr.send(null)
                return xhr.status === okStatus ? xhr.responseText : null
            },

            unicodeToUtf8(data){
                data = data.replace(/\\/g,'%')
                return unescape(data)
            }
        },
  
    }
</script>

<style lang="scss" scoped>
    .Product-shop{
        display: flex;
        padding: 30px 0;
        flex-direction: column;
        margin: 0 auto;
        @media screen and (max-width:400px) {
            width: 100%;
            margin: 0 auto;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            width: 100%;
            margin: 0 auto !important;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            width: 1000px;
            margin: 0 auto;
        }
        @media screen and (min-width:1601px){
            width: 1200px;
            margin: 0 auto; 
        }
    }
    .Product-shop h2{
        text-align: center;
        @media screen and (max-width:400px) {
            font-size: 22px;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            font-size: 24px;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            font-size: 18px;
        }
        @media screen and (min-width:1601px){
            font-size: 22px; 
        }
    }
    .Product-shop h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Product-li{
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px;
        @media screen and (max-width:400px) {
            padding: 10px 15px;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            padding: 15px 0px;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            padding: 18px 0px;
        }
        @media screen and (min-width:1601px){
            padding: 20px 0px; 
        }
    }
    .img-and-name{
        @media screen and (max-width:400px) {
            display: flex;
            flex-direction: column;
            margin-left: 1rem;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            display: flex;
            flex-direction: column;
            margin-left: 1rem;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-left: 0px;
        }
        @media screen and (min-width:1601px){
            display: flex;
            flex-direction: row;
            align-items: center; 
        }
    }
    .Product-img{
        @media screen and (max-width:400px) {
            width: 4rem;
            height: 4rem;
            display: block;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            width: 6rem;
            height: 6rem;
            display: block;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            width: 60px;
            height: 60px;
            display: block;
        }
        @media screen and (min-width:1601px){
            width:  60px;
            height: 60px;
            display: block; 
        }
    }
    .Product-name{
        font-size: 18px;
        margin-left: 5px;
        @media screen and (max-width:400px) {
            text-align: left;
            font-size: 16px;
            margin-left: 1rem;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            text-align: left;
            font-size: 16px;
            margin-left: 1rem;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            font-size: 16px;
            margin-left: 5px;
        }
        @media screen and (min-width:1601px){
            font-size: 18px;
            margin-left: 5px;
        }
    }
    .Product-download{
        cursor: pointer;
        display: block;
        @media screen and (max-width:400px) {
            width: 4rem;
            height: 3rem;
            margin-right: 2rem;
        }
        @media screen and (min-width:400px) and (max-width:1200px){
            width: 4rem;
            height: 3rem;
            margin-right: 2rem;
        }
        @media screen and (min-width:1200px) and (max-width:1600px){
            width: 40px;
            height: 30px;
            margin-right: 10px;
        }
        @media screen and (min-width:1601px){
            width: 40px;
            height: 30px;
            margin-right: 10px;
        }
    }
</style>
